import classes from "./PlansAndCreditsLearnMore.module.scss";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../components/ui/CustomButton/CustomButton";

const PlansAndCreditsLearnMore = () => {
  const { t } = useTranslation();

  return (
    <div className={classes["page"]}>
      <section className={classes["referral"]}>
        <div className="container">
          <div className={classes["wrapper"]}>
            <div className={classes["first-box"]}>
              <h1>{t("HowToReferAFriendToClubPass")}</h1>
              <p dangerouslySetInnerHTML={{ __html: t("OnTheAppLogIntoTheClubPassApp") }}></p>
              <p
                dangerouslySetInnerHTML={{
                  __html: t("OnOurWebsiteLogIntoYourAccountOnTheClubPassWebsite"),
                }}
              ></p>
              <div className={classes["btn-wrapper"]}>
                <CustomButton text={t("GetStarted")} type={"button"} typeStyle={"fill"} />
              </div>
            </div>
            <div className={classes["second-box"]}>
              <h2>{t("HowYouWillBeRewarded")}</h2>
              <p>{t("ForEveryFriendWhoUsesYourReferral")}</p>
              <p>{t("ToDetermineYourReferralReward")}</p>
            </div>
          </div>
          <div className={classes["btn-wrapper-2"]}>
            <CustomButton text={t("GetStarted")} type={"button"} typeStyle={"fill"} />
          </div>
        </div>
      </section>

      <section className={classes["loyalty"]}>
        <div className="container">
          <h2 className={classes["title"]}>{t("EarnEvenMoreWithOOurLoyaltyProgram")}</h2>
          <div className={classes["wrapper"]}>
            <div className={classes["item"]}>
              <h2>{t("TrainMoreEarnMore")}</h2>
              <p>{t("JoinOurLoyaltyProgramAndGet")}</p>
              <p>{t("CollectPointsAndUseThemToward")}</p>
            </div>
          </div>
          <div className={classes["btn-wrapper"]}>
            <CustomButton text={t("GetStarted")} type={"button"} typeStyle={"fill"} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default PlansAndCreditsLearnMore;
